import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import {
  Button,
  Col,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Steps,
  Tag,
} from 'antd'
import QuestHeader from './components/QuestHeader.jsx'
import history from '../../history.js'
import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import actions from '../../store/actions/index.js'
import './quest.scss'
import Badge from '../Courses/Create/nestedComponents/CourseCreateMain/components/Badge'
import Certificate from '../Courses/Create/nestedComponents/CourseCreateMain/components/Certificate'
import StoryModal from './components/StoryModal.jsx'
import ContentChoiceStep from '../../components/ContentChoiceSelection/ContentChoiceSetup.jsx'
import { api } from '../../services/index.js'
import { ImageSelect } from '../../components/Form/index.js'

const { Step } = Steps
const { Option } = Select

const ageGroupOptions = [
  { label: 'Preschool (3-5)', value: '3-5' },
  { label: 'Elementary (6-10)', value: '6-10' },
  { label: 'Middle School (11-13)', value: '11-13' },
  { label: 'High School (14-18)', value: '14-18' },
  { label: 'Adults (18+)', value: '18+' }
]
const QuestCreateUpdate = ({ form, upload, user }) => {
  const {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    getFieldValue,
    setFieldsValue
  } = form

  const { t } = useTranslation()
  const { active_organization_id, id: user_id } = user?.info

  const [activityModalVisible, setActivityModalVisible] = useState(false)
  const [storyModalVisible, setStoryModalVisible] = useState(false)
  const [activeIndex, setActiveIndex] = useState(null)
  const [certModal, setCertModal] = useState({
    isCertificateLoading: false,
    open: false
  })
  const [badgeModal, setBadgeModal] = useState({
    isBadgeLoading: false,
    open: false
  })
  const [isFetching, setIsFetching] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [isUploadingFile, setIsUploadingFile] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [current, setCurrent] = useState(0)
  const pdfRef = useRef(null)
  const [generatedContent, setGeneratedContent] = useState([])
  const [contentSource, setContentSource] = useState('internet')
  const [isGenerating, setIsGenerating] = useState(false)
  const [coverImg, setCoverImg] = useState(null)
  const [steps] = useState([
    { title: 'Basic Info', value: 0 },
    { title: 'Quest Parameters', value: 1 },
    { title: 'Quest Content', value: 2 }
  ])
  const [formData, setFormData] = useState({
    cover_id: '',
    file_list: "",
    org_id: String(active_organization_id),
    user_id: String(user_id),
    title: '',
    age_group: '',
    objectives: "",
    num_steps: null,
    points_per_stop: null,
    max_story_words: null,
    story_preferences: null,
    editor_user_ids: []
  })
  const [selectedCover, setSelectedCover] = useState({
    id: '',
    link: '',
    file_size: '',
    filename: ''
  })
  const [attachedData, setAttachedData] = useState({
    filenames: [],
    attachmentIds: []
  })
  const [attachedFiles, setAttachedFiles] = useState({
    filenames: [],
    attachmentIds: []
  })
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const stepParam = searchParams.get('step')

    if (stepParam && !isNaN(stepParam)) {
      setCurrent(Number(stepParam - 1))
    }
    if (!formData.title) {
      setCurrent(0)
    }
  }, [])

  useEffect(() => {
    history.push(
      `quest-create?step=${current === 0 ? 1 : current === 1 ? 2 : 3}`
    )
  }, [current])

  const togglePanel = index => {
    setActiveIndex(prev => (prev === index ? null : index))
  }
  const syncFormData = () => {
    const values = form.getFieldsValue()
    const newFormData = { ...formData }
    Object.keys(values).forEach(key => {
      _.set(newFormData, key, values[key])
    })
    newFormData.file_list = attachedData?.filenames.map(f => f.path)
    setFormData(newFormData)
    return newFormData
  }

  const handleNext = () => {
    validateFields(['title', 'cover_id'], (err) => {
      if (!err) {
        syncFormData()
        setCurrent(current + 1)
      }
    })
  }
  const handleBack = () => {
    syncFormData()
    setCurrent(current - 1)
  }
  const navigateTo = () => {
    history.push('/quest-list')
  }
  // Load dummy generated content when moving to step 3
  const generateDummyContent = async () => {
    validateFields(async (err) => {
      if (err) return

      setIsGenerating(true)
      try {
        const currentValues = syncFormData()
        const res = await api.quest.generateQuestContent(currentValues)
        if (res && res.status === 200) {
          if (res.data && res.data.stops) {
            setGeneratedContent(res.data.stops)
            setCurrent(current + 1)
            message.success('Quest content generated successfully')
          } else {
            message.error('Unexpected response format: stops data missing')
          }
        } else {
          message.error(`Failed to generate quest: ${res.statusText || 'Unknown error'}`)
        }
      } catch (error) {
        console.error(error)
        message.error('An error occurred while generating quest content')
      } finally {
        setIsGenerating(false)
      }
    })
  }
  const handleDownloadPdf = async () => {
    if (!generatedContent || generatedContent.length === 0) {
      message.warning('No content available to export.')
      return
    }

    setIsExporting(true)
    const hideLoading = message.loading('Preparing PDF...', 0)

    try {
      // We'll create a temporary div for the printable content
      const printArea = document.getElementById('quest-pdf-print-area')
      if (!printArea) throw new Error('Print area not found')

      // Temporarily show it for capture
      printArea.style.display = 'block'

      const canvas = await html2canvas(printArea, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      })

      printArea.style.display = 'none'

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()
      const imgWidth = canvas.width
      const imgHeight = canvas.height
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
      const imgX = (pdfWidth - imgWidth * ratio) / 2
      const imgY = 10 // Margin top

      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio)
      pdf.save(`Quest_Export_${formData.title.replace(/\s+/g, '_')}.pdf`)
      message.success('Quest PDF downloaded successfully!')
    } catch (error) {
      console.error('PDF Export Error:', error)
      message.error('Failed to generate PDF. Please try again.')
    } finally {
      hideLoading()
      setIsExporting(false)
    }
  }

  const badgePresentationUpload = (body, imageType) => {
    const isCertificate = imageType === 'Certificate'

    const toggleLoading = loading => {
      if (isCertificate) {
        setCertModal({ open: false, isCertificateLoading: loading })
      } else {
        setBadgeModal({ open: false, isBadgeLoading: loading })
      }
    }
    const updateFormDataWithId = id => {
      setFormData({
        ...formData,
        ...(isCertificate ? { certId: id } : { badgeId: id })
      })
    }

    toggleLoading(true)
    upload(body)
      .then(res => {
        toggleLoading(false)
        updateFormDataWithId(res.id)
      })
      .catch(() => {
        toggleLoading(false)
        message.error(t('v4:error_occured_try_again'))
      })
  }
  const setStoryMode = newValue => {
    setFormData({
      ...formData,
      story_preferences: newValue
    })
    setFieldsValue({ story_preferences: newValue })
    setStoryModalVisible(false)
  }
  const onFiles = filesArray => {
    if (_.isEmpty(filesArray) && _.isEmpty(attachedData.attachmentIds)) return
    const filesById = filesArray.map(item => item.id)
    filesById &&
      setAttachedData({
        ...attachedData,
        filenames: filesArray,
        attachmentIds: filesById
      })
  }
  const handleDocumentSelect = (value) => {
    console.log('test document select', value)
  }
  const handleFinalSubmit = (value) => {
    if (value.length === 0) {
      setContentSource('organization')
    } else {
      setContentSource('document')
      onFiles(value)
    }
  }

  const onCoverChange = async coverObj => {
    setFieldsValue({ cover_id: coverObj.id })
    setFormData({
      ...formData,
      cover_id: coverObj.id
    })
  }
  return (
    <Spin spinning={isFetching}>
      <section className="section" style={{ paddingBottom: '10rem' }}>
        <QuestHeader t={t} type={"Create"} />
        <Row gutter={[16, 16]} justify="center" type="flex">
          <Col xs={24} sm={24} md={20} lg={18} xl={16}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 20
              }}
            >
              <Steps current={current} style={{ marginBottom: 24 }}>
                {steps.map(item => (
                  <Step key={item.value} title={item.title} />
                ))}
              </Steps>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <div className="form-body">
              <Form layout="vertical">
                <div style={{ display: current === 0 ? 'block' : 'none' }}>
                  <Row gutter={[16, 16]} justify="center" type="flex">
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <Form.Item
                        label="Title of the Quest"
                        colon={false}
                        required
                      >
                        {getFieldDecorator('title', {
                          initialValue: formData.title,
                          rules: [
                            {
                              required: true,
                              message: 'Please input Quest Title!'
                            }
                          ]
                        })(<Input placeholder="Quest Title" />)}
                      </Form.Item>
                    </Col>
                    <Col span={24}></Col>
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <Form.Item
                        required={false}
                        colon={false}
                        className="no_bottom_margin"
                      >
                        {getFieldDecorator('cover_id', {
                          initialValue: formData.cover_id,
                          rules: [
                            {
                              required: true,
                              message: t('v3:required_cover_image')
                            }
                          ]
                        })(
                          <ImageSelect
                            form={form}
                            required={false}
                            label={t('v4:cover_picture')}
                            coverInput={coverImg}
                            onCoverChange={onCoverChange}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={24}></Col>
                    <Col xs={24} sm={24} md={12} lg={10}>
                      <div style={{
                        color: "#212121",
                        textTransform: "capitalize",
                        fontWeight: "600",
                        fontSize: "14px",
                        paddingBottom: "8px"
                      }}>
                        Upload Files (word files, pdf)
                      </div>
                      <ContentChoiceStep
                        isCourse={false}
                        onSelect={handleDocumentSelect}
                        handleFinalSubmit={handleFinalSubmit}
                        isSubmitting={isGenerating}
                        onUploadingChange={setIsUploading}
                      /></Col>

                  </Row>
                </div>
                <div style={{ display: current === 1 ? 'block' : 'none' }}>
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Name of the Quest">
                        <Input disabled value={getFieldValue('title') || formData.title} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Age Group" required>
                        {getFieldDecorator('age_group', {
                          initialValue: formData.age_group,
                          rules: [{ required: true, message: 'Please select Age Group!' }]
                        })(
                          <Select size="large" placeholder="Select age group">
                            {ageGroupOptions.map(opt => (
                              <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item label="Objectives" required>
                        {getFieldDecorator('objectives', {
                          initialValue: formData.objectives,
                          rules: [{ required: true, message: 'Please input Objectives!' }]
                        })(<Input.TextArea rows={4} />)}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Number of steps" required>
                        {getFieldDecorator('num_steps', {
                          initialValue: formData.num_steps,
                          rules: [
                            { required: true, message: 'Please input number of steps!' },
                            {
                              type: 'number',
                              min: 1,
                              max: 25,
                              message: 'Number of steps must be between 1 and 25'
                            }
                          ]
                        })(
                          <InputNumber
                            size="large"
                            style={{ width: '100%', borderRadius: 4 }}
                            min={1}
                            max={25}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Points per stop" required>
                        {getFieldDecorator('points_per_stop', {
                          initialValue: formData.points_per_stop,
                          rules: [
                            { required: true, message: 'Please input points per stop!' },
                            {
                              type: 'number',
                              min: 1,
                              max: 100,
                              message: 'Points per stop must be between 1 and 100'
                            }
                          ]
                        })(
                          <InputNumber
                            min={1}
                            max={100}
                            size="large"
                            style={{ width: '100%', borderRadius: 4 }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Max Story Words" required>
                        {getFieldDecorator('max_story_words', {
                          initialValue: formData.max_story_words,
                          rules: [{ required: true, message: 'Please input max story words!' }]
                        })(
                          <InputNumber
                            min={1}
                            size="large"
                            style={{ width: '100%', borderRadius: 4 }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Story Preferences" required>
                        {getFieldDecorator('story_preferences', {
                          initialValue: formData.story_preferences,
                          rules: [
                            {
                              required: true,
                              message: 'Please set your story preferences!'
                            }
                          ]
                        })(
                          <Button
                            onClick={() => setStoryModalVisible(true)}
                            type={
                              getFieldValue('story_preferences')
                                ? 'primary'
                                : 'default'
                            }
                            style={{ width: 200 }}
                          >
                            {getFieldValue('story_preferences') && (
                              <Icon type="check" />
                            )}{' '}
                            Set Story Mode
                          </Button>
                        )}
                      </Form.Item>
                      <StoryModal
                        form={form}
                        setStoryMode={setStoryMode}
                        visible={storyModalVisible}
                        onCancel={() => setStoryModalVisible(false)}
                      />
                    </Col>
                  </Row>
                </div>
              </Form>

              {current === 2 && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 16
                    }}
                  >
                    <div className="quest-contain-title">Generated Quest</div>
                    {/* <Button
                      type="primary"
                      icon="download"
                      loading={isExporting}
                      onClick={handleDownloadPdf}
                    >
                      Download PDF Export
                    </Button> */}
                  </div>
                  <div className="accordion">
                    {generatedContent.map((content, index) => (
                      <div className="accordion__item" key={index}>
                        <div
                          className={`accordion__header ${activeIndex === index ? 'active' : ''
                            }`}
                          onClick={() => togglePanel(index)}
                        >
                          <div className="accordion__title">
                            <span className="accordion__step-num">#{content.number || index + 1}</span>
                            {content.title}
                          </div>
                          <div className="accordion__meta">
                            <Tag
                              style={{ backgroundColor: '#f0f5ff', color: '#1d39c4', border: '1px solid #adc6ff' }}
                            >
                              {content.points || 100} Points
                            </Tag>
                            &nbsp;
                            <Icon type={activeIndex === index ? 'up' : 'down'} />
                          </div>
                        </div>

                        <div
                          className={`accordion__body ${activeIndex === index ? 'open' : ''
                            }`}
                        >
                          <div className="accordion__content corporate-style">
                            <div className="accordion__section">
                              <h4 className="corporate-label">Mission Narrative</h4>
                              <p className="corporate-text">{content.story}</p>
                            </div>

                            <div className="accordion__grid">
                              <div className="accordion__section">
                                <h4 className="corporate-label">Fun Fact</h4>
                                <div className="corporate-insight">
                                  <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                  {content.fun_fact}
                                </div>
                              </div>
                              <div className="accordion__section">
                                <h4 className="corporate-label">Open Ended Question</h4>
                                <p className="corporate-text-secondary">{content.quiz?.open_ended}</p>
                              </div>
                            </div>

                            <div className="accordion__grid">
                              <div className="accordion__section">
                                <h4 className="corporate-label">Knowledge Check</h4>
                                <div className="quiz-box">
                                  <div className="quiz-question">
                                    <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                    {content.quiz?.multiple_choice?.question}
                                  </div>
                                  <ul className="quiz-options">
                                    {content.quiz?.multiple_choice?.options?.map((opt, i) => (
                                      <li key={i}>
                                        {opt}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              {content.clue && (
                                <div className="accordion__section">
                                  <h4 className="corporate-label">Mission Hints</h4>
                                  {content.clue && (
                                    <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                      <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{content.clue.narrative_content}</div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <div className="accordion__location_grid">
                              {content.location && (
                                <div className="accordion__section">
                                  <h4 className="corporate-label">Location Hints</h4>
                                  {content.location && (
                                    <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                      <Icon type="environment" style={{ color: '#1890ff', marginRight: 8 }} />
                                      <strong>{content.location.name}</strong>
                                      <div style={{ marginLeft: 24, fontSize: '12px', color: '#8c8c8c' }}>{content.location.address}</div>
                                    </div>
                                  )}
                                  <div className="corporate-hints">
                                    {content.clue?.mission_context && (
                                      <div className="hint-item">
                                        <span className="hint-label">Mission Context:</span>
                                        <span className="hint-value">{content.clue.mission_context}</span>
                                      </div>
                                    )}
                                    {content.clue?.location_clues && (
                                      <div className="hint-item">
                                        <span className="hint-label">Location Clues:</span>
                                        <div className="tag-group" style={{ display: 'block' }}>
                                          {content.clue.location_clues.map((c, i) => (
                                            <div key={i} className="corporate-text-secondary" style={{ marginBottom: 4 }}>• {c}</div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                    {content.clue?.confirmation && (
                                      <div className="hint-item">
                                        <span className="hint-label">Confirmation:</span>
                                        <span className="hint-value" style={{ color: '#52c41a', fontWeight: 600 }}>{content.clue.confirmation}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </section>
      <div className="p-footer">
        <div className="p-footer__inner">
          {!isFetching && (
            <div className="p-footer__item">
              <Fragment>
                &nbsp;
                <span>
                  {current === 0 && (
                    <Fragment>
                      <Button
                        type="primary"
                        className="rounded"
                        onClick={navigateTo}
                        style={{ marginRight: 8 }}
                      >  <Icon type="left" />
                        Back to Quest List
                      </Button>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isUploading}
                        disabled={isUploading}
                        onClick={handleNext}
                      >
                        Next Step
                        <Icon type="right" />
                      </Button>
                    </Fragment>
                  )}
                  {current === 1 && (
                    <Fragment>
                      <Button
                        type="primary"
                        className="rounded"
                        disabled={isGenerating}
                        onClick={handleBack}
                        style={{ marginRight: 8 }}
                      >
                        <Icon type="left" />
                        Previous
                      </Button>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isGenerating}
                        onClick={generateDummyContent}
                      >
                        Generate Content
                        <Icon type="right" />
                      </Button>
                    </Fragment>
                  )}
                  {current === 2 && (
                    <Fragment>
                      <Button
                        type="primary"
                        className="rounded"
                        onClick={navigateTo}
                      >  <Icon type="left" />
                        Back to Quest List
                      </Button>
                    </Fragment>
                  )}
                </span>
              </Fragment>
            </div>
          )}
        </div>
      </div>
      <Modal
        style={{ top: 1 }}
        bodyStyle={{ height: 'auto' }}
        visible={badgeModal.open}
        onCancel={() => {
          setBadgeModal({ ...badgeModal, open: false })
        }}
        footer={null}
        width="1229px"
        centered
      >
        <Badge onUploadImage={body => badgePresentationUpload(body, 'Badge')} />
      </Modal>
      <Modal
        style={{ top: 1 }}
        bodyStyle={{ height: 'auto' }}
        visible={certModal.open}
        onCancel={() => {
          setCertModal({ ...certModal, open: false })
        }}
        footer={null}
        width="1229px"
        centered
      >
        <Certificate
          type={'Course'}
          onUploadImage={body => badgePresentationUpload(body, 'Certificate')}
        />
      </Modal>

      {/* Hidden container for PDF generation */}
      <div id="quest-pdf-print-area" style={{
        display: 'none',
        width: '800px',
        padding: '40px',
        background: '#fff',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial'
      }}>
        <div style={{ borderBottom: '2px solid #1890ff', paddingBottom: '10px', marginBottom: '20px' }}>
          <h1 style={{ color: '#000', margin: 0, fontSize: '24px' }}>{formData.title}</h1>
          <p style={{ color: '#595959', margin: '5px 0 0', fontSize: '13px' }}>
            Age Group: {formData.age_group} | Genre: {formData.story_preferences?.genre} | Tone: {formData.story_preferences?.tone}
          </p>
        </div>

        {generatedContent.map((content, index) => (
          <div key={index} style={{ marginBottom: '25px', borderBottom: '1px solid #f0f0f0', paddingBottom: '20px' }}>
            <div style={{
              background: '#f0f5ff',
              padding: '10px 15px',
              borderRadius: '6px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px'
            }}>
              <h2 style={{ margin: 0, fontSize: '16px', color: '#1d39c4' }}>
                #{content.number || index + 1} {content.title}
              </h2>
              <span style={{ fontWeight: 'bold' }}>{content.points || 100} PTS</span>
            </div>

            <div style={{ padding: '0 5px' }}>
              <h4 style={{ color: '#8c8c8c', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px', marginBottom: '6px' }}>Mission Narrative</h4>
              <p style={{ fontSize: '13px', lineHeight: '1.5', marginBottom: '16px', color: '#262626' }}>{content.story}</p>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '16px' }}>
                <div>
                  <h4 style={{ color: '#8c8c8c', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px', marginBottom: '6px' }}>Fun Fact</h4>
                  <div style={{ background: '#fffbe6', padding: '8px 12px', borderRadius: '4px', fontSize: '12px', color: '#856404', border: '1px solid #ffe58f' }}>
                    {content.fun_fact}
                  </div>
                </div>
                <div>
                  <h4 style={{ color: '#8c8c8c', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px', marginBottom: '6px' }}>Location Hints</h4>
                  <div style={{ background: '#f0f7ff', padding: '8px 12px', borderRadius: '4px', fontSize: '12px', color: '#003a8c', border: '1px solid #bae7ff' }}>
                    <strong>Atmosphere:</strong> {content.location_hints?.atmosphere}<br />
                    <strong>Requirements:</strong> {content.location_hints?.requirements}
                  </div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div>
                  <h4 style={{ color: '#8c8c8c', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px', marginBottom: '6px' }}>Knowledge Check</h4>
                  <div style={{ border: '1px solid #e8e8e8', borderRadius: '4px', padding: '8px 12px' }}>
                    <p style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '6px', color: '#262626' }}>{content.quiz?.multiple_choice?.question}</p>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '11px' }}>
                      {content.quiz?.multiple_choice?.options?.map((opt, i) => (
                        <li key={i} style={{
                          padding: '2px 0',
                          color: i === content.quiz?.multiple_choice?.correct_index ? '#237804' : '#595959',
                          fontWeight: i === content.quiz?.multiple_choice?.correct_index ? 'bold' : 'normal'
                        }}>
                          • {opt} {i === content.quiz?.multiple_choice?.correct_index ? '(Correct)' : ''}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div>
                  <h4 style={{ color: '#8c8c8c', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px', marginBottom: '6px' }}>Strategic Inquiry</h4>
                  <div style={{ fontSize: '12px', color: '#595959', backgroundColor: '#fafafa', padding: '8px 12px', borderRadius: '4px', fontStyle: 'italic', borderLeft: '3px solid #d9d9d9' }}>
                    {content.quiz?.open_ended}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '10px', color: '#bfbfbf' }}>
          Generated by Sharelook Quest AI
        </div>
      </div>
    </Spin>
  )
}
const mapStateToProps = state => ({
  organizations: state.organizations.list,
  user: state.user
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      upload: (file, opts) => dispatch(actions.library.upload(file, opts)),
      updateTopicList: actions.topics.updateTopicList
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'quest_form' })(QuestCreateUpdate))

